import React, { useState, useContext } from "react";
import Chart from "react-apexcharts";
import { TableDataContext } from '../index';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";
import CustomProgress from "./CustomProgress";
import Popup from "../../../Components/Popup";
import { escapeCsv } from "../../../JS/Common";
import useConfig from "../../../Hooks/useConfig";

export default function BreakageRate(props) {
    const { decimalRange, hover_type, department, students, student, show_breakage_rate, specific_student } = useConfig();
    const { AllDashBoardData } = useContext(TableDataContext);
    const [ModalShow, setModalShow] = useState(false)
    const Open = () => {
        setModalShow(true)
    }
    const categories = AllDashBoardData?.Breakageratebybuilding?.data?.categories || [];
    const series = (AllDashBoardData?.Breakageratebybuilding?.data?.series || [])?.map((value) => parseFloat(value)?.toFixed(decimalRange));
    const abbreviatedCategories = categories?.map(label => label?.length > 25 ? label?.substring(0, 25) + '...' : label);
    const options = {
        chart: {
            height: 350,
            type: "bar",
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: "top", // Place labels on top of the bars
                },
            },
        },
        xaxis: {
            categories: abbreviatedCategories,
            title: {
                text: "Buildings",
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return parseFloat(val)?.toFixed(decimalRange);
                },
            },
            title: {
                text: "Breakage Rate",
            },
        },
        dataLabels: {
            style: {
                colors: ["black"],
            },
        },
        chart: {
            toolbar: {
                show: false,
            },
        },
        colors: ["var(--primary-color)"],
        states: {
            hover: {
                filter: {
                    type: hover_type
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "Breakage Rate " + val;
                },
                title: {
                    formatter: function (seriesName, val) {
                        return "";
                    },
                },
            },
        },
    };
    const series1 = (AllDashBoardData?.Breakageratebygrade?.data?.series || [])?.map((value) => parseFloat(value)?.toFixed(decimalRange));
    const options1 = {
        chart: {
            height: 350,
            type: "bar",
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: "top", // Place labels on top of the bars
                },
            },
        },
        xaxis: {
            categories: AllDashBoardData?.Breakageratebygrade?.data?.categories || [],
            title: {
                text: department || "Grades",
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return parseFloat(val)?.toFixed(decimalRange);
                },
            },
            title: {
                text: "Breakage Rate",
            },
        },
        dataLabels: {
            style: {
                colors: ["black"],
            },
        },
        chart: {
            toolbar: {
                show: false,
            },
        },
        colors: ["var(--primary-color)"],
        states: {
            hover: {
                filter: {
                    type: hover_type
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "Breakage Rate " + val;
                },
                title: {
                    formatter: function (seriesName, val) {
                        return "";
                    },
                },
            },
        },
    };
    const series2 = (AllDashBoardData?.Breakageratebyuser?.data?.series || [])?.map((value) => parseFloat(value)?.toFixed(decimalRange));
    const options2 = {
        chart: {
            height: 350,
            type: "bar",
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: "top", // Place labels on top of the bars
                },
            },
        },
        xaxis: {
            categories: AllDashBoardData?.Breakageratebyuser?.data?.categories || [],
            title: {
                text: `${specific_student}s`,
            },
        },
        yaxis: {
            labels: {
                formatter: function (val) {
                    return parseFloat(val)?.toFixed(decimalRange);
                },
            },
            title: {
                text: "Breakage Rate",
            },
        },
        dataLabels: {
            style: {
                colors: ["black"],
            },
        },
        chart: {
            toolbar: {
                show: false,
            },
        },
        colors: ["var(--primary-color)"],
        states: {
            hover: {
                filter: {
                    type: hover_type
                }
            }
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "Breakage Rate " + val;
                },
                title: {
                    formatter: function (seriesName, val) {
                        return "";
                    },
                },
            },
        },
    };
    const modalbody = (
        <>
            <div className="my-4">
                <div className="col-12 text-center  greyBoxShadow" style={{ height: "100%", borderRadius: "10px", backgroundColor: "white" }}>
                    <div className="w-100">
                        <h5 className="text-center pt-3">Breakage rate by building</h5>
                        {AllDashBoardData?.Breakageratebybuilding?.loader ? <><div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div></> : <>
                            {series && series?.length > 0 ? (
                                <div style={{ overflowX: "scroll" }}>
                                    <div className="" style={{
                                        width: series?.length > 10 ? "1500px" : "100%",
                                    }}>
                                        <Chart options={options} series={[{ data: series }]} type="bar" height={200} />
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center p-3">No data available</div>
                            )}
                        </>}
                    </div>
                </div>
            </div>
            {show_breakage_rate &&
                <div className="my-4">
                    <div className="col-12 text-center  greyBoxShadow" style={{ height: "100%", borderRadius: "10px", backgroundColor: "white" }}>
                        <div className="w-100">
                            <h5 className="text-center pt-3">Breakage rate by {department || "grade"}</h5>
                            {AllDashBoardData?.Breakageratebygrade?.loader ? <><div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div></> : <>
                                <div className="">
                                    {series1 && series1?.length > 0 ? (
                                        <div style={{ overflowX: "scroll" }}>
                                            <div className="" style={{
                                                width: series1?.length > 10 ? "1500px" : "100%",
                                            }}>
                                                <Chart options={options1} series={[{ data: series1 }]} type="bar" height={200} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center p-3">No data available</div>
                                    )}
                                </div>
                            </>}
                        </div>
                    </div>
                </div>
            }
            <div className="my-4">
                <div className="col-12 text-center  greyBoxShadow" style={{ height: "100%", borderRadius: "10px", backgroundColor: "white" }}>
                    <div className="w-100">
                        <h5 className="text-center pt-3">Breakage rate by {specific_student}</h5>
                        {AllDashBoardData?.Breakageratebyuser?.loader ? <><div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div></> : <>
                            <div className="">
                                {series2 && series2?.length > 0 ? (
                                    <div style={{ overflowX: "scroll" }}>
                                        <div className="" style={{
                                            width: series2?.length > 10 ? "1500px" : "100%",
                                        }}>
                                            <Chart options={options2} series={[{ data: series2 }]} type="bar" height={200} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center p-3">No data available</div>
                                )}
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </>
    )
    const downloadCSV = () => {
        const csvContent = [];
        const rows = [];

        // Add headers once
        csvContent.push(['Ticket Number', 'Serial Number', 'Asset Tag', 'Status']);

        AllDashBoardData?.BreakageRate?.data?.total_ticket?.forEach((ticket, i) => {
            const rowData = {
                'Ticket Number': ticket.ticket_number || '-',
                'Serial Number': escapeCsv(ticket?.serial_number) || '-',
                'Asset Tag': escapeCsv(ticket?.asset_tag) || '-',
                'Status': escapeCsv(ticket?.ticket_status) || '-',
            };
            rows.push(rowData);
        });

        rows.forEach((rowData) => {
            const values = Object.values(rowData);
            csvContent.push(values);
        });

        const csvString = csvContent.map(row => row.join(',')).join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'BreakageRateData.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <React.Fragment>
            <div className="col-12 text-center  greyBoxShadow">
                <div className="w-100">
                    <div className="position-relative">
                        <div className="row mt-2 px-2 time">
                            <div className='Header'>
                                <b className='font-15'>Breakage Rate </b><br />
                            </div>
                        </div>
                        <div className="position-absolute top-0 end-0 cursor-pointer" onClick={Open}>
                            <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} />
                        </div>
                    </div>
                    {AllDashBoardData?.BreakageRate?.loader ?
                        <div className='row'>
                            <div className="col-12 text-center pt-2">
                                <img src="/images/loder.svg" className="" style={{ width: "30px" }} />
                            </div>
                        </div>
                        : <div className="py-4 progress-container">
                            <CustomProgress
                                percentage={AllDashBoardData?.BreakageRate?.data?.data || 0}
                                size={{ width: 230, height: 290 }}
                                strokeWidth={5}
                                strokeColor="var(--primary-color)"
                                hasBackground
                            />
                            <div className="col-12 text-center">
                                <div>Total Tickets Created: <b>{AllDashBoardData?.BreakageRate?.data?.total_tickets || 0}</b></div>
                                <div>Total Devices: <b>{AllDashBoardData?.BreakageRate?.data?.total_devices || 0}</b></div>
                                <div>Days Between Dates: <b>{AllDashBoardData?.BreakageRate?.data?.days_elapsed || 0}</b></div>
                            </div>
                            <div className="col-12 text-center py-2">
                                <label className="cursor-pointer text-decoration-underline" onClick={downloadCSV}>Download CSV</label>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <Popup isshow={ModalShow} size={"lg"} title={"Device Breakage Rate"}
                closePopup={(e) => setModalShow(false)}
                modalBody={modalbody} visibleSaveBtn={false} />
        </React.Fragment>
    );
};

